export default {
  "content": "<g clip-path=\"url(#clip0_431_53627)\"><path d=\"M12 0C5.37 0 0 4.81 0 10.74c0 5.93 5.37 10.75 12 10.75 1.1 0 2.196-.141 3.26-.42a2 2 0 011.47.18l4.15 2.34a.75.75 0 001.12-.66v-5.6a2 2 0 01.39-1.15A8.81 8.81 0 0024 10.74C24 4.81 18.63 0 12 0zM6 13a2 2 0 110-4 2 2 0 010 4zm6 0a2 2 0 110-4 2 2 0 010 4zm6 0a2 2 0 110-4 2 2 0 010 4z\" fill=\"#3F4450\"/></g><defs><clipPath id=\"clip0_431_53627\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"/></clipPath></defs>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};